module.exports = __webpack_public_path__ + "img/logo_v2_black.4e420556.png";